module.exports = __webpack_public_path__ + "static/media/icon_partner_instagram.9c4a2a52.svg";